import { uuid } from "uuidv4"
import { trackEvent } from "./serverSide"
import { GiftCardPurchaseOption } from "../../types/gift-card";
import { dataLayerPush } from "../analytics";

export const trackWalletPurchaseLoad = (action) => {
    trackEvent(
        'ViewContent',
        uuid(),
        {
            content_ids: ['wallet'],
            content_type: 'product',
            content_name: 'Wallet Catalog',
            currency: 'MXN',
            value: 0,
            content_category: 'Wallet'
        }
    );
    
    dataLayerPush({
        event: 'view_item_list',
        currency: "MXN",
        item_list_name: "Wallet Catalog",
        items: action.payload.cardTypes.map(type => ({
            item_id: `wallet_${type}`,
            item_name: type,
        }))
    });
};

export const trackWalletPurchaseByTypeLoad = (type: string, cards: GiftCardPurchaseOption[]) => {
    trackEvent(
        'ViewContent',
        uuid(),
        {
            content_ids: [`wallet_${type}`],
            content_type: 'product',
            content_name: `Wallet ${type}`,
            currency: 'MXN',
            value: 0,
            content_category: `Wallet > ${type}`
        }
    );

    dataLayerPush({
        event: 'view_item_list',
        currency: "MXN",
        item_list_name: `Wallet ${type}`,
        items: cards.filter(card => card.type === type).map(card => ({
            item_id: `wallet_${type}_${card.id}`,
            item_name: `${type} - ${card.name}`,
        }))
    });
};

export const trackWalletPurchaseOptionSelect = (option: GiftCardPurchaseOption, customAmount: number | null) => {
    trackEvent(
        'AddToCart',
        uuid(),
        {
            content_ids: [`wallet_${option.type}_${option.id}`],
            content_type: 'product',
            content_name: `Initiate Checkout - ${option.type} - ${option.name}`,
            currency: 'MXN',
            value: customAmount || option.price,
            content_category: `Wallet > ${option.type} > ${option.name}`
        }
    );

    dataLayerPush({
        event: 'add_to_cart',
        currency: "MXN",
        value: customAmount || option.price,
        items: [{
            item_id: `wallet_${option.type}_${option.id}`,
            item_name: `${option.type} - ${option.name}`,
            price: customAmount || option.price,
            quantity: 1
        }]
    });
};

export const trackWalletPurchaseComplete = (option: GiftCardPurchaseOption, customAmount: number | null, isGift: boolean, result) => {
    trackEvent(
        'Purchase',
        uuid(),
        {
            content_ids: [`wallet_${option.type}_${option.id}`],
            content_type: 'product',
            content_name: `Purchase Confirmation - ${option.type} - ${option.name}`,
            currency: 'MXN',
            value: customAmount || option.price,
            content_category: `Wallet > ${option.type} > ${option.name}`,
            is_gift: isGift
        }
    );
    
    dataLayerPush({
        event: 'purchase',
        currency: "MXN",
        value: customAmount || option.price,
        transaction_id: `wallet_${result.transaction_id}`,
        items: [{
            item_id: `wallet_${option.type}_${option.id}`,
            item_name: `${option.type} - ${option.name}`,
            price: customAmount || option.price,
            quantity: 1
        }]
    });
};